import { render, staticRenderFns } from "./important-information-detail.view.vue?vue&type=template&id=441425ba&"
import script from "./important-information-detail.view.vue?vue&type=script&lang=ts&"
export * from "./important-information-detail.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports